import { CommonModule, DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { indicadorAlertaPermanencia } from '../../../modal/indicadorAlertaPermanencia';
import { StatusIndicadorAlerta } from '../../../utilidades/enum/status.indicador.alerta.enum';
import { posto_simple } from '../../../modal/posto_simple';
import { mensagem } from '../../../modal/mensagem';
import { DateTimeFormatPipe } from '../../../utilidades/date-time-format.pipe';
import { TimeFormatPipe } from '../../../utilidades/time-format.pipe';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import html2canvas from 'html2canvas';
import { FormControl, FormsModule } from '@angular/forms';
import * as ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { StatusCorIndicadorAlerta } from '../../../utilidades/enum/status.cor.indicardor.alerta.enum';
import $ from 'jquery'; // Import jQuery
import { MultipleSelectionSelectAllComponent } from '../../../utilidades/multiple-selection-select-all/multiple-selection-select-all.component';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PostoService } from '../../../service/posto.service';
import { RegiaoService } from '../../../service/regiao.service';
import { LogosBase64 } from '../../../utilidades/logosBase64'
import { Console } from 'console';
import { RelatorioService } from '../../../service/relatorio.service';
import { PostoPonto } from '../../../utilidades/interfaceRelatorioPontoAtendimento';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import FileSaver from 'file-saver';

@Component({
  selector: 'app-cidadao-espera-criti-roxo',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatCardModule,
    FormsModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    MultipleSelectionSelectAllComponent,
    MatFormFieldModule, MatDatepickerModule
  ],
  templateUrl: './horas-produtivas.component.html',
  styleUrl: './horas-produtivas.component.scss',
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    TimeFormatPipe, DateTimeFormatPipe, provideNativeDateAdapter()]
})


export class HorasProdutivasComponent implements OnInit {
  public SemDados: boolean = false;
  larguraTela: number = window.innerWidth;
  login: string | null | undefined = null;
  data: PostoPonto[] = [];
  dataMensagem = [];
  listaPostos: any = [];
  listaRegiao: any = [];
  RegiaoSelecionada: any;
  PostosSelecionados: any[] = [];
  usuario: any;
  feitaPesquisa: boolean = true;

  campoOrdenado: string = '';
  ordem: 'asc' | 'desc' = 'asc';


  constructor(private route: ActivatedRoute, private router: Router,
    private relatorioService: RelatorioService, @Inject(DOCUMENT) private document: Document,
    private postoService: PostoService, private regiaoService: RegiaoService,
    public timeFormatPipe: TimeFormatPipe,
    public dateTimeFormatPipe: DateTimeFormatPipe) {
    try {
      const localStorage = document.defaultView?.localStorage;
      if (localStorage)
        this.login = localStorage.getItem('login');
      if (this.login == null || this.login == undefined)
        this.router.navigate(['/iniciar']);
    }
    catch (ex) {
      this.router.navigate(['/iniciar']);
    }
  }
  ngOnInit() {
    let login = localStorage.getItem('login');
    this.usuario = localStorage.getItem('salaSituacao');
    this.listarPostos();
  }
  processarInfo(info: any) {
    this.PostosSelecionados = info;
  }

  getTotalAtendimentos(ponto: any): number {
    return ponto.pontosAtendimentos.reduce((sum: number, pa: any) => sum + pa.atendimentos.length, 0);
  }

  listarPostos() {
    let sala: any = localStorage.getItem('salaSituacao');
    sala = JSON.parse(sala);
    this.postoService.getPostoUsuario(this.usuario).pipe().subscribe((result: any) => {
      result.Posto.forEach((posto: any) => {
        this.listaPostos.push(posto);
      });

      this.listaPostos.sort(function (a: any, b: any) {
        if (a.descricao > b.descricao) {
          return 1;
        }
        if (a.descricao < b.descricao) {
          return -1;
        }
        return 0;
      })
    })
  }

  onSelecionar(valor: string) {
    this.RegiaoSelecionada = valor; // Atualiza o valor quando o select muda
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.larguraTela = window.innerWidth;
  }

  Pesquisa() {
    if (this.PostosSelecionados.length != 0) {
      this.feitaPesquisa = false;

      console.log(this.PostosSelecionados.toString());
      this.data = [];
      var retrievedObject = localStorage.getItem('salaSituacao');
      if (retrievedObject != null) {
        var sala = JSON.parse(retrievedObject);
        this.relatorioService.getRelatorioHorasProdutivas(sala['postos'], this.PostosSelecionados.toString(), 5).pipe(
        ).subscribe((response: PostoPonto[]) => {
          console.log(response);
          if (response.length == 0)
            this.SemDados = true;
          else
            this.SemDados = false;
          this.data = response;
        });
      }
    }
    else {
      this.feitaPesquisa = true;
      this.data = [];
    }
  }

  filtrarPesquisa() {
    this.Pesquisa();
  }

  exportarParaExcel(): void {
    const data: any[] = [];

    this.data.forEach(posto => {
      posto.pontosAtendimentos.forEach((ponto, pontoIndex) => {
        ponto.atendimentos.forEach((horario, horarioIndex) => {
          data.push({
            //Posto: horarioIndex === 0 && pontoIndex === 0 ? posto.descricao : '',
            //Ponto: horarioIndex === 0 ? ponto.descricao : '',
            'Posto': posto.descricao,
            'Ponto Atendimento	': ponto.descricao,
            'Atendente': horario.nomeAtendente,
            'Data': this.dateTimeFormatPipe.transformSemHora(horario.abertura),
            'Hora Início': this.dateTimeFormatPipe.transformSoHora(horario.abertura),
            'Hora Final': this.dateTimeFormatPipe.transformSoHora(horario.fechamento),
            'Tempo Atendimento (min)': horario.tempoAtendimento != undefined ? this.formatMillisSoMin(horario.tempoAtendimento) : ""
          });
        });
      });
    });

    const worksheet: XLSX.WorkSheet = {};
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
    const formattedTime = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate} - ${formattedTime}`;
    XLSX.utils.sheet_add_aoa(worksheet, [['Relatório de Ponto de Atendimento - Emitido por: ' + this.login + " - " + formattedDateTime]], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(worksheet, [[]], { origin: 'A2' });
    XLSX.utils.sheet_add_json(worksheet, data, { origin: 'A3' });
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Relatório': worksheet },
      SheetNames: ['Relatório']
    };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const formattedDate2 = today.toISOString().split('T')[0];
    FileSaver.saveAs(dataBlob, 'relatorio_horas-produtivas' + formattedDate2 + '.xlsx');
  }

  exportToPDF() {
    const body: any[] = [];

    body.push([
      { text: 'Posto', style: 'tableHeader' },
      { text: 'Ponto Atendimento', style: 'tableHeader' },
      { text: 'Atendente', style: 'tableHeader' },
      { text: 'Data', style: 'tableHeader' },
      { text: 'Hora Início', style: 'tableHeader' },
      { text: 'Hora Final', style: 'tableHeader' },
      { text: 'Tempo Atendimento', style: 'tableHeader' },
    ]);

    for (const item of this.data) {
      for (const ponto of item.pontosAtendimentos) {
        const atendimentos = ponto.atendimentos;

        for (let i = 0; i < atendimentos.length; i++) {
          const atendimento = atendimentos[i];

          const row: any[] = [];

          if (i === 0) {
            row.push({
              text: item.descricao,
              rowSpan: atendimentos.length
            });
          } else {
            row.push({});
          }

          if (i === 0) {
            row.push({
              text: ponto.descricao,
              rowSpan: atendimentos.length
            });
          } else {
            row.push({});
          }
          row.push({ text: atendimento.nomeAtendente });
          row.push({ text: this.dateTimeFormatPipe.transformSemHora(atendimento.abertura) });
          row.push({ text: this.dateTimeFormatPipe.transformSoHora(atendimento.abertura) });
          row.push({ text: this.dateTimeFormatPipe.transformSoHora(atendimento.fechamento) });
          if (atendimento.tempoAtendimento != undefined)
            row.push({ text: this.formatMillis(atendimento.tempoAtendimento) });
          else
            row.push({});


          body.push(row);
        }
      }
    }
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
    const formattedTime = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate} - ${formattedTime}`;
    const docDefinition: TDocumentDefinitions = {
      content: [
        {
          columns: [
            {
              image: LogosBase64.logo1,
              width: 100,
              alignment: 'left',
              margin: [0, 0, 10, 0]
            },
            {
              width: "*", // Ocupa o espaço do meio
              text: "" // Espaço vazio entre os logos
            },
            {
              width: "auto", // Ajusta ao conteúdo dos logos
              alignment: "right",
              columnGap: 35, // Espaço fixo entre os logos
              columns: [
                {
                  image: LogosBase64.logo2,
                  width: 60,

                },
                {
                  image: LogosBase64.logo3,
                  width: 60,

                },
                {
                  image: LogosBase64.logo4,
                  width: 60,

                }
              ]
            }
          ]
        },
        {
          text: `Relatório: Horas Produtivas`,
          style: 'header'
        },
        {
          columns: [

            {
              width: "auto", // Garante que o login não fique comprimido
              text: `Emitido por: ${this.login}` + ` - ` + `Data ${formattedDateTime}`,
              style: 'posto',
              fontSize: 8,
              margin: [0, 30, 0, 10],// Adiciona um espaçamento superior
              noWrap: true // Impede a quebra do texto
            },
          ]
        },
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: body,
          },
          fontSize: 10,
          layout: 'lightHorizontalLines'
        },
        {
          text: [
            { text: "Rua Agueda Gonçalves, 240 - Taboão da Serra - SP, 06760-900 - Tel:(11)28456000 (PABX)\n", fontSize: 8, alignment: 'center' },
            { text: "Correspondência: Caixa Postal 25901 - CEP: 05513-970 - SÃO PAULO-SP\n", fontSize: 8, alignment: 'center' },
            { text: "www.prodesp.sp.gov.br - prodesp@prodesp.sp.gov.br", fontSize: 8, alignment: 'center' }
          ],
          margin: [0, 10, 0, 0] // Remove espaçamento entre as linhas
        }
      ],
      styles: {
        header: {
          fontSize: 6,
          bold: true,
          alignment: 'center' as const // Alinhar texto centralizado
        },
        tableHeader: {
          bold: true,
          fillColor: '#eeeeee'
        }
      }
    };
    const formattedDate2 = today.toISOString().split('T')[0];
    pdfMake.createPdf(docDefinition).download('relatorio_horas_produtivas-' + formattedDate2 + '.pdf');
  }

  formatDate(value: number | string): string {
    if (value == null || value == "") {
      return "";
    }
    const date = new Date(value);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getLetterFromNumber(num: number): string {
    const baseCharCode = 'A'.charCodeAt(0); // Código ASCII para 'A'
    return String.fromCharCode(baseCharCode + num - 1);
  }

  getTodayDate(): string {
    const date = new Date();
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  formatMillis(millis: number): string {
    if (!millis || millis < 0) return '0min';

    // total de minutos (arredondado para cima)
    const totalMinutes = Math.ceil(millis / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}min`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${minutes}min`;
    }
  }

  formatMillisSoMin(millis: number): string {
    if (!millis || millis < 0) return '0min';

    return "" + Math.floor(millis / (1000 * 60));
  }

  ordenarAtendimentosInternos(campo: string): void {
    // Alterna a ordem se o mesmo campo for clicado novamente
    if (this.campoOrdenado === campo) {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc';
    } else {
      this.campoOrdenado = campo;
      this.ordem = 'asc';
    }
  
    // Ordenação por Posto (nível externo: data[])
    if (campo === 'posto') {
      this.data.sort((a, b) => {
        const valA = a.descricao?.toLowerCase() || '';
        const valB = b.descricao?.toLowerCase() || '';
        return this.ordem === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
      });
      return; // IMPORTANTE: evita executar o restante da ordenação
    }
  
    // Ordenação por Ponto de Atendimento (nível intermediário)
    if (campo === 'pontoAtendimento') {
      for (const item of this.data) {
        item.pontosAtendimentos.sort((a, b) => {
          const valA = a.descricao?.toLowerCase() || '';
          const valB = b.descricao?.toLowerCase() || '';
          return this.ordem === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        });
      }
      return;
    }
  
    // Ordenação dos atendimentos (nível interno)
    for (const item of this.data) {
      for (const ponto of item.pontosAtendimentos) {
        ponto.atendimentos.sort((a, b) => {
          let valA: any;
          let valB: any;
  
          switch (campo) {
            case 'nomeAtendente':
              valA = a.nomeAtendente?.toLowerCase() || '';
              valB = b.nomeAtendente?.toLowerCase() || '';
              break;
            case 'data':
            case 'horaInicio':
              valA = new Date(a.abertura).getTime() || 0;
              valB = new Date(b.abertura).getTime() || 0;
              break;
            case 'horaFim':
              valA = new Date(a.fechamento).getTime() || 0;
              valB = new Date(b.fechamento).getTime() || 0;
              break;
            case 'tempoAtendimento':
              valA = a.tempoAtendimento ?? 0;
              valB = b.tempoAtendimento ?? 0;
              break;
            default:
              valA = '';
              valB = '';
          }
  
          return this.ordem === 'asc'
            ? valA > valB ? 1 : valA < valB ? -1 : 0
            : valA < valB ? 1 : valA > valB ? -1 : 0;
        });
      }
    }
  }
  
  
  

  
}